export default __webpack_public_path__ + "static/media/uxui-design.f754b7a7.svg";